<template>
    <div :class="['slack-channel', {'p-workspace-layout': replies_active, 'p-workspace-layout--only-replies': replies_in_full_width}]">
        <div
            class="p-workspace__primary_view"
            v-show="!(replies_in_full_width && replies_active)"
        >
          <div id="ban">
            <div class="banner" @click="goToBottom()"><h2>Go to Down</h2></div>
          </div>
            <div class="slack-chat-container">
                <div
                    class="slack-chat"
                    ref="chat"
                >
                    <template v-for="(item, item_key) in items" :key=item_key>
                        <div
                            class="slack-ts"
                            v-if="item.type === 'ts' && item.messages.length"
                            :key="`ts-${item_key}`"
                        >
                            <div class="slack-ts-text">{{ item.date_text }}</div>
                        </div>
                        <template style="display: block">
                            <div v-for="(msg, key) in item.messages">
                              <slack-message
                                  :channel="channel"
                                  :msg="msg"
                                  :key="`item-${item_key}-msg-${key}`"
                                  @add_reaction="show_emoji_picker"
                                  @show_replies="show_replies(msg)"
                                  @updated="updated"
                              />
                            </div>
                        </template>
                    </template>
                </div>
                <div></div>
            </div>
            <div class="slack-message-container">
                <slack-message-editor @message="messages.push($event)" />
            </div>
            <slack-emoji-picker
                ref="emoji_picker"
                @selected="handle_add_reaction(selected_msg, $event)"
            />
        </div>
        <slack-message-replies
            v-if="replies_active && selected_msg"
            :channel="channel"
            :message="selected_msg"
            @close="close_replies"
            @updated="updated"
        />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { delete_message, is_me, is_pinned, list_conversation, reactions } from '../slack_api'
import SlackIconButton from './SlackIconButton'
import SlackMessageEditor from './editor/SlackMessageEditor'
import SlackEmojiPicker from './emoji-picker/SlackEmojiPicker'
import SlackMessage from './message/SlackMessage.vue'
import SlackMessageReplies from './replies/SlackMessageReplies'
export default {
    components: {
        SlackMessage,
        SlackMessageReplies,
        SlackEmojiPicker,
        SlackIconButton,
        SlackMessageEditor,
    },
    computed: {
        ...mapGetters([
            'slack_channels',
            'slack_is_signed_in',
        ]),
        oldest() {
            const l = this.messages.length
            return l && this.messages[l - 1].ts || null
        }
    },
    data() {
        return {
            interval_id: null,
            items: [],
            messages: [],
            now: new Date(),
            replies_active: false,
            selected_msg: null,
        }
    },
    methods: {
      goToBottom(){
        // $(".slack-chat").scrollTop($(document).height());
        return $('.slack-chat').animate({scrollTop: $(".slack-chat")[0].scrollHeight},"fast");
      },
      toggleBanner(){
        $(".slack-chat").scroll(function (e) {
          let height = Math.floor(e.target.scrollHeight - e.target.clientHeight)
          if (e.target.scrollTop < height){
            $(".banner").show()
          }
          else{
            $(".banner").hide()
          }
        })
      },
        close_replies() {
            this.replies_active = false
            this.selected_msg = null
        },
        confirm_delete_message(msg) {
            return this.confirmMessage(
                'Confirm action',
                'Confirm delete message?',
                'Yes'
            ).then(() => {
                delete_message(this.channel, msg.ts).then(({ ok }) => {
                    if (!ok) {
                        this.errorMessage('Error deleting message')
                        return
                    }
                    const idx = this.messages.findIndex(i => i.ts === msg.ts)
                    if (idx !== -1) {
                        delete this.messages[idx]
                    }
                    this.process_messages(true)
                    this.$forceUpdate()
                    this.successMessage('Message deleted successfull')
                }, () => this.errorMessage('Error deleting message'))
            }, r => Promise.reject(r))
        },
        get_date_text(ts) {
            let date = new Date(ts), date_text = null, now = this.now
            const hours = (now.getTime() - date.getTime()) / (60 * 60 * 1000)
            if (hours < 24) {
                date_text = 'Today'
            } else if (hours < 48) {
                date_text = 'Yesterday'
            } else {
                date_text = moment(date).format('dddd, MMMM Do')
            }
            return date_text
        },
        handle_add_reaction(msg, { emoji, name, skin_tone }) {
            this.$refs.emoji_picker.hide()
            const reacted = msg.reactions && msg.reactions.some(r => r.name === name && r.users.some(u => is_me(u)))
            reactions(name, msg.ts, this.channel, reacted ? 'remove' : 'add').then(res => {
                if (res.ok) {
                    this.update_item(msg)
                }
            })
        },
        init(clear = true) {
            if (clear) {
                this.messages = []
            }
            return new Promise((resolve, reject) => {
                this.channel && list_conversation(this.channel).then(response => {
                    const { messages } = response
                    this.messages = messages.filter(msg => msg.type === 'message').reverse()
                    this.process_messages(true)
                    resolve()
                }) || reject()
            })
        },
        is_pinned,
        poll_for_new_messages() {
            const { oldest } = this
                , params = { inclusive: true }
            if (oldest) {
                params.oldest = oldest
                params.inclusive = false
                params.limit = 1
            }
            list_conversation(this.channel, params).then(response => {
                if (!response.ok || !response.messages.length) {
                    return
                }
                const { messages } = response, msg = messages[0], ts = parseFloat(msg.ts) * 1000, date_text = this.get_date_text(ts)
                let ts_item
                this.messages.push(msg)
                const idx = this.items.findIndex(i => i.date_text === date_text)
                if (idx === -1) {
                    ts_item = { date_text, messages: [], type: 'ts' }
                    this.items.push(ts_item)
                } else {
                    ts_item = this.items[idx]
                }
                ts_item.messages.push(msg)
                this.$forceUpdate()
            })
        },
        process_messages(scrollToBottom = false) {
            let date_text = null
            this.items = []
            this.messages.forEach(msg => {
                const ts = parseFloat(msg.ts) * 1000
                let ts_item
                date_text = this.get_date_text(ts)
                const idx = this.items.findIndex(i => i.date_text === date_text)
                if (idx === -1) {
                    ts_item = { date_text, messages: [], type: 'ts' }
                    this.items.push(ts_item)
                } else {
                    ts_item = this.items[idx]
                }
                ts_item.messages.push(msg)
            })
            scrollToBottom && this.$nextTick(() => {
                const chat = this.$refs.chat
                chat.scrollTo(0, chat.scrollHeight)
            })
        },
        show_emoji_picker({ e, msg, type = 'reaction' }) {
            this.$nextTick(() => {
                this.selected_msg = msg
                this.$nextTick(() => {
                    this.$refs.emoji_picker.show(e)
                })
            })
        },
        show_replies(msg) {
            this.selected_msg = msg
            this.replies_active = true
        },
        start_interval() {
            if (this.interval_id !== null) {
                clearInterval(this.interval_id)
                this.interval_id = null
            }
            if (!this.slack_is_signed_in) {
                return
            }
            this.interval_id = setInterval(() => {
                if (this.slack_is_signed_in) {
                    this.poll_for_new_messages()
                } else {
                    clearInterval(this.interval_id)
                    this.interval_id = null
                }
            }, 4000)
        },
        turnoff_notifications(item) {
            item.notifications_disabled = !item.notifications_disabled
            this.$forceUpdate()
        },
        update_item(msg) {
            list_conversation(this.channel, { inclusive: true, latest: msg.ts, limit: 1 }).then(response => {
                if (!response.ok) {
                    return
                }
                const { messages } = response
                this.updated(messages[0])
            })
        },
        updated(msg) {
            const msg_idx = this.messages.findIndex(i => i.ts === msg.ts)
            this.items.some(i => {
                const idx = i.messages.findIndex(m => m.ts === msg.ts)
                if (idx !== -1) {
                    i.messages[idx] = msg
                    return true
                }
            })
            if (msg_idx !== -1) {
                this.messages[msg_idx] = msg
                if (this.selected_msg && this.selected_msg.ts === msg.ts) {
                    this.selected_msg = msg
                }
            }
            this.$forceUpdate()
        },
    },
    mounted() {
      //this.toggleBanner()
        this.init()
        if (this.slack_is_signed_in) {
            this.start_interval()
        }
        if (this.$route.name === "emails.view"){
          this.$router.push({ name: "emails.view", params: { selected_id: this.channel } })
        }
    },
    props: ['channel', 'replies_in_full_width'],
    unmounted() {
        if (this.interval_id) {
            clearInterval(this.interval_id)
        }
    },
    watch: {
        messages() {
            this.process_messages()
        },
        slack_is_signed_in(slack_is_signed_in) {
            this.start_interval()
        }
    },
}
</script>
<style lang="sass">
.slack-channel
  background-color: #fff
  border-radius: 10px
  font-size: 15px
  .slack-chat-container
    margin-bottom: 16px
    position: relative
    .slack-chat
      max-height: calc(100vh - 452px)
      overflow-y: auto
      .slack-ts
        padding: 12px 0
        position: relative
        &:before
          content: ' '
          left: 0
          right: 0
          border-top: 1px solid rgba(var(--sk_foreground_low_solid,221,221,221),1)
          border-bottom: 0
          margin: 0 0 -1px
          top: 14px
          position: absolute
        .slack-ts-text
          background-color: white
          border-radius: 24px
          box-shadow: 0 0 0 1px rgba(29,28,29,0.13),0 1px 3px 0 rgba(0,0,0,.08)
          font-size: 13px
          font-weight: 700
          height: 28px
          left: 50%
          line-height: 27px
          padding: 0 16px
          pointer-events: all
          position: absolute
          top: 0
          transform: translateX(-50%)
          white-space: nowrap
  .slack-message-container
    display: flex
    flex: 1
    flex-direction: column
    padding: 0 20px
.p-workspace-layout
  grid-template-columns: auto 400px
  grid-template-areas: 'p-workspace__primary_view p-workspace__secondary_view'
  max-height: calc(100vh - 355px)
  &--only-replies
    grid-template-columns: auto auto
    grid-template-areas: 'p-workspace__secondary_view'
    max-height: unset
    .slack-chat-container .slack-chat
      max-height: 600px
  .p-workspace__primary_view
    display: flex
    flex-direction: column

#ban
  transition: all 2s

.banner
  height: 20px
  background-color: purple
  color: white
  cursor: pointer
  display: none


.banner h2
  display: inline

.hide
  display: none

.show
  display: block

</style>